import {Injectable} from '@angular/core';
import {FormsHelper} from '../helpers/FormsHelper';
import {AccountService} from './account.service';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class SubAccountService {

    private subAccountData;

    constructor(
        private accountService: AccountService
    ) {
    }

    clearSubAccountData() {
        this.subAccountData = null;
    }

    setSubAccountDataById(id) {
        const subAccounts = this.accountService.subAccounts ?? [];
        this.subAccount = subAccounts.find((subAccount: any) => String(subAccount?.id) === String(id))
            ?? subAccounts[0]
            ?? {id, addressInfo: {}};
    }

    private set subAccount(subAccount) {
        this.subAccountData = subAccount;
    }

    get id() {
        return this.subAccountData?.id;
    }

    get credits() {
        return this.subAccountData?.credits;
    }

    get subAccountName() {
        return this.subAccountData?.name ?? '';
    }

    get createdBy() {
        return (this.subAccountData?.createdBy?.fullName) ? this.subAccountData.createdBy.fullName : 'NA';
    }

    get modifiedBy() {
        return (this.subAccountData?.modifiedBy?.fullName) ? this.subAccountData.modifiedBy.fullName : 'NA';
    }

    get status() {
        return this.subAccountData?.status;
    }

    get employeesNumber() {
        return this.subAccountData?.employeesNumber;
    }

    get addressInfo() {
        const subAccountData = this.subAccountData ?? {addressInfo: {}};
        let addressInfo = {};
        for (let field of FormsHelper.fieldsName(FormsHelper.addressInfo)) {
            if (subAccountData.addressInfo && subAccountData.addressInfo[field]) {
                addressInfo[field] = subAccountData.addressInfo[field];
            } else {
                if (subAccountData.hasOwnProperty(field)) {
                    addressInfo[field] = subAccountData[field];
                } else {
                    addressInfo[field] = '';
                }
            }
        }
        return addressInfo;
    }

    get phoneNumber() {
        return this.subAccountData?.phoneNumber;
    }

    get webSite() {
        return this.subAccountData?.webSite;
    }
}
